import {splitStringWithDelimiter} from './utils';
import {h, type JSX} from '@stencil/core';

export const highlightText = (text:string, searchTerm:string): JSX.Element => {
    const parts = splitStringWithDelimiter(text, searchTerm);
    return parts.map(part=>{

        //when the part is the search term, we wrap it with JSX span/highlight element - for highlighting
        if(part.toLowerCase() == searchTerm.toLowerCase()){
          return <span class="highlight">{part}</span>;
        }

        //otherwise we just return the plain value
        return part;

    });

};
